import React, { useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import SensitiveSectionConfirmDialog from '../components/SensitiveSectionConfirmDialog';

export default function MonitoraggioSicCai() {
  const navigate = useNavigate();
  const [confirmOpen, setConfirmOpen] = useState(true);
  const message = useMemo(
    () =>
      'Stai per accedere alle Visure CAI. Questa sezione può mostrare informazioni sensibili (dati creditizi, segnalazioni e storico consultazioni).\n\nAssicurati di avere un motivo legittimo e l’autorizzazione necessaria, in conformità alla normativa privacy e alle policy aziendali.\n\nPer motivi di sicurezza, l’accesso a questa sezione può essere tracciato e registrato nei log di sistema.',
    []
  );

  const cancel = () => {
    setConfirmOpen(false);
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate('/', { replace: true });
  };

  const confirm = () => {
    setConfirmOpen(false);
  };

  return (
    <Box sx={{ p: 3 }}>
      <SensitiveSectionConfirmDialog
        open={confirmOpen}
        title="Conferma Accesso Dati Sensibili"
        message={message}
        onCancel={cancel}
        onConfirm={confirm}
      />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              bgcolor: '#fff7ed',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <AlertTriangle size={20} color="#f97316" />
          </Box>
          <Box>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'text.primary' }}>
              CAI Centrale Allarme Interbancaria
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Sezione predisposta per monitoraggio CAI, esiti, documentazione e tracciamento richieste.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Card
        sx={{
          p: 3,
          borderRadius: '16px',
          boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)'
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1.25 }}>
          Roadmap
        </Typography>
        <Box component="ul" sx={{ pl: 3, m: 0 }}>
          {[
            'Ricerca pratiche e soggetti (CF/P.IVA)',
            'Caricamento documenti e ricevute',
            'Stato richiesta e storico esiti',
            'Alert e scadenze di monitoraggio'
          ].map((text) => (
            <Box component="li" key={text} sx={{ mb: 0.75 }}>
              <Typography variant="body1">{text}</Typography>
            </Box>
          ))}
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Pagina predisposta. In attesa delle specifiche funzionali.
        </Typography>
      </Card>
    </Box>
  );
}
